import React, { Component, createContext } from 'react';
import { Link } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
// import { ReactComponent as HappyMealBoxSvg } from '../../assets/svg/happy-meal-box.svg';
import StoreDropdown, { StoreContext } from '../StoreDropdown';
import GetAppButton from '../GetAppButton';

export const AnimationContext = createContext('');

export default class Home extends Component {
  static contextType = AnimationContext;
  state = {
    radioId: '',
    url: '',
    showStore: false,
    isLoading: true,
  }

  constructor(props) {
    super(props);
    this.headerVideo = React.createRef();
  }

  componentDidMount() {
    // setTimeout(() => {
    //   // this.context.setIntro(false);
    // }, 2000);

    // if (!this.context.playIntro) {
    //   this.setState({ showStore: true });
    // }
    this.setState({ showStore: true });
  }

  updateRadioId = (id) => this.setState({ radioId: id });
  updateURL = (url) => this.setState({ url });

  render() {
    let contextState = {
      update: this.updateRadioId,
      updateURL: this.updateURL,
      url: this.state.url,
      value: this.state.radioId,
    }

    return (
      <StoreContext.Provider value={contextState}>
        <div className="wrapper">
          <Container className="fill">
            <Row className="fill">
              <Col className="logo-container">

                {/* <div className={`box-wrapper`}>
                  <video muted playsInline autoPlay id="video" preload={'auto'} type={'video/mp4'}>
                    <source src="/videos/McD_Box_Pop.webm" type="video/webm"></source>
                    <source src="/videos/McD_Box_Pop.mp4" type="video/mp4"></source>
                  </video>
                </div> */}

                <CSSTransition in={(this.state.showStore)} timeout={600} unmountOnExit classNames="store">
                  <div className={`homepage`}>
                    {/* <h1>Happy Meal App</h1> */}
                    <div className="logo logo-title">
                      <Link to="/">
                        {/* <HappyMealBoxSvg /> */}
                        <img className="img-responsive" src="./img/logo-with-title.png" alt=""/>
                      </Link>
                    </div>
                    <StoreDropdown />
                    <GetAppButton />
                    <div className="footer-links">
                      <Link to="/legal">Legal</Link> |
                      <Link to="/faq">FAQs</Link>
                    </div>
                  </div>
                </CSSTransition>

              </Col>
            </Row>
          </Container>
        </div>
      </StoreContext.Provider>
    )
  }
}
